import { cx } from "@emotion/css";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createLinkStyles } from "../helpers/createLinkStyles";

interface InternalLinkProps {
  to: string;
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
  title?: string;
  onClick?: () => void;
}

export function InternalLink({
  to,
  className,
  children,
  disabled,
  title,
  onClick,
}: InternalLinkProps) {
  const classes = createLinkStyles(useTheme());

  if (disabled) {
    return <span className={cx(classes.disabled, className)}>{children}</span>;
  }
  return (
    <RouterLink
      className={cx(classes.root, className)}
      to={to}
      title={title}
      onClick={onClick}
    >
      {children}
    </RouterLink>
  );
}
